module.exports = __webpack_public_path__ + "img/Groups-Served.3c35b5e5.svg";